var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCi = function SvgCi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M16.174.746A11.975 11.975 0 0 0 12.001 0c-1.468 0-2.874.264-4.174.746L6.783 12l1.044 11.253c1.3.482 2.706.747 4.174.747 1.467 0 2.873-.265 4.173-.747L17.218 12 16.174.746Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009E60",
    d: "M24 12c0-5.16-3.257-9.558-7.826-11.253v22.507C20.744 21.558 24 17.16 24 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F77F00",
    d: "M0 12c0 5.159 3.256 9.558 7.826 11.253V.746C3.256 2.44 0 6.84 0 11.999Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgCi;